<template>
  <v-autocomplete
    v-model="value"
    :disabled="isDisabled"
    :items="items"
    color="clr-primary"
    :label="label"
    :item-text="itemText"
    :item-value="itemValue"
    height="50"
    class="c-selector single"
    :no-data-text="$T('common.no_data')"
  >
    <template slot="selection" slot-scope="data">
      <v-list-tile-avatar>
        <c-img :src="'/cover/cm/' + data.item.id + ''" />
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title>{{ getCmName(data.item) }}</v-list-tile-title>
        <v-list-tile-sub-title v-if="subContent == 'role'">{{ $utils.role(data.item.role) }}</v-list-tile-sub-title>
      </v-list-tile-content>
    </template>
    <template slot="item" slot-scope="data">
      <template v-if="typeof data.item !== 'object'">
        <v-list-tile-content v-text="data.item"></v-list-tile-content>
      </template>
      <template v-else>
        <v-list-tile-avatar>
          <c-img :src="'/cover/cm/' + data.item.id + '/'" />
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>{{ getCmName(data.item) }}</v-list-tile-title>
          <v-list-tile-sub-title v-if="subContent == 'role'">{{ $utils.role(data.item.role) }}</v-list-tile-sub-title>
        </v-list-tile-content>
      </template>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  props: {
    label: { type: String, required: true },
    itemText: { type: String, required: true },
    itemValue: { type: String, required: true },
    initItems: { type: Array, required: true },
    initValue: { type: Number, required: false },
    subContent: { type: String, required: false },
    disabled: { type: Boolean, required: false, default: false },
  },
  watch: {
    value(newValue, oldValue) {
      this.$emit('change-value', newValue);
    },
    disabled(newVal, oldVal) {
      this.isDisabled = newVal;
    },
  },
  data() {
    return {
      value: this.initValue,
      isDisabled: this.disabled,
    };
  },
  computed: {
    items() {
      if (!this.initItems) return [];
      return this.initItems.filter(cm => {
        return !cm.guest;
      });
    },
  },
  methods: {
    getValue() {
      return this.value;
    },
    addError(fieldName, value, msg) {
      if (!this.apiErrors) this.apiErrors = {};
      if (!this.apiErrors[fieldName]) this.apiErrors[fieldName] = {};
      this.apiErrors[fieldName][value] = msg;
      this.reValidate();
    },
    getMessage(fieldName) {
      return this.apiErrors[fieldName] && this.apiErrors[fieldName][this.inputValue]
        ? this.apiErrors[fieldName][this.inputValue]
        : this.errors.collect(fieldName);
    },
    reValidate() {
      this.$validator.validateAll();
      this.$refs['input_' + this.fieldName].focus();
      this.loading = false;
    },
  },
};
</script>
